import { render, staticRenderFns } from "./DeviceAccess.vue?vue&type=template&id=22e7b055&"
import script from "./DeviceAccess.vue?vue&type=script&lang=js&"
export * from "./DeviceAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports